mutation requestPasswordReset($input: SendResetOrVerificationMailInput!) {
  sendResetOrVerificationMail(input: $input) {
    status
    message
    errorCode
  }
}
